import React from 'react';
import axios from 'axios';
import ajax from '../../helpers/ajax';
import RenderFormPublicar from './RenderFormPublicar';

export default class ContainerFormPublicar extends React.Component {
	constructor(props) {
		super(props);
		this.onSubmitPublicar = this.onSubmitPublicar.bind(this);
		
		this.state = {
			mostrarMensajeDeEnvio:false,
		};
	}

	onSubmitPublicar(values){
		let loc = values.localidad;
		if (this.props.precarga && this.props.precarga.localidad) {
			loc = !values.localidad ? this.props.precarga.localidad : values.localidad; 
		}
		dataLayer.push({
            'event': 'Consulta Publicar',
            'exitoConsulta': 1
        });
		axios
		.post('/api/v1/formPublicar/',{
			nombreApellido:values.nombreApellido,
			telefono:values.telefono,
			email:values.email,
			unidades:values.unidades,
			localidad:loc,
			mensaje:values.mensaje,
			to:this.props.to,
		})
		.then((result) => {
			this.setState({ mostrarMensajeDeEnvio: true })
		}) 
		.catch((err) => console.log(err));
	}

	render(){
		return <RenderFormPublicar
					onSubmit={this.onSubmitPublicar}
					mostrarMensajeDeEnvio={this.state.mostrarMensajeDeEnvio}
					onCloseModal={this.props.onCloseModal}
					buttonClass={this.props.buttonClass}
					precarga={this.props.precarga}
				/>
	}
}